export const variants = [
  {
    props: { variant: "Light Green" },
    style: ({ theme }) => ({
      backgroundColor: theme.palette.background.button,
      borderRadius: theme.shape.borderRadius * 2,
      "&:hover": {
        color: theme.palette.text.button,
        backgroundColor: theme.palette.background.button_hover,
      },
      "&.Mui-disabled": {
        backgroundColor: theme.palette.background.button_disabled,
      },
    }),
  },
  {
    props: { variant: "Navigation" },
    style: ({ theme }) => ({
      color: theme.palette.text.navigation,
      "&:hover": {
        backgroundColor: theme.palette.background.button,
      },
    }),
  },
];
